import type {PageRouteConfig} from '@router';

import ProPaymentSuccess from 'modules/Services/PromotionCenter/Pro/PaymentSuccess/ProPaymentSuccess';

export function createPromotionCenterProPaymentSuccessRoute(): PageRouteConfig {
  return {
    element: <ProPaymentSuccess />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
